<template>
    <div class="fixed inset-0 z-10 overflow-y-auto" v-show="open">
        <div
            class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0"
        >
            <transition
                enter-active-class="transition duration-300 ease-out transform"
                enter-class="opacity-0 "
                enter-to-class="opacity-100 "
                leave-active-class="transition duration-200 ease-in transform"
                leave-class="opacity-100 "
                leave-to-class="opacity-0"
                v-show="open"
            >
                <div class="fixed inset-0 transition-opacity">
                    <div
                        @click="close"
                        class="absolute inset-0 bg-gray-500 opacity-75"
                    ></div>
                </div>
            </transition>

            <!-- This element is to trick the browser into centering the modal contents. -->
            <span
                class="hidden sm:inline-block sm:align-middle sm:h-screen"
            ></span>
            <transition
                enter-active-class="transition duration-300 ease-out transform"
                enter-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
                enter-to-class="translate-y-0 opacity-100 sm:scale-100"
                leave-active-class="transition duration-200 transform"
                leave-class="translate-y-0 opacity-100 sm:scale-100"
                leave-to-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
                v-show="open"
            >
                <div
                    class="z-20 inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:w-full"
                    :class="!isIframe ? 'sm:max-w-2xl' : 'sm:max-w-6xl'"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="modal-headline"
                >
                    <div class="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                        <div class="sm:flex sm:items-start">
                            <div
                                class="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-blue-100 rounded-full sm:mx-0 sm:h-10 sm:w-10"
                                v-if="!isIframe"
                            >
                                <!-- <svg class="w-6 h-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 5v8a2 2 0 01-2 2h-5l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2zM7 8H5v2h2V8zm2 0h2v2H9V8zm6 0h-2v2h2V8z" />
                </svg> -->
                                <svg
                                    class="w-6 h-6"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    ></path>
                                </svg>
                            </div>
                            <div
                                class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left"
                            >
                                <!-- <h3 class="text-lg font-medium leading-6 text-gray-900" id="modal-headline">
                  Coûts des facteurs - Emploi
                </h3> -->
                                <div class="mt-2">
                                    <!-- <p class="text-sm leading-5 text-gray-500">
                    Are you sure you want to deactivate your account? All of your data will be permanently removed. This action cannot be undone.
                  </p> -->
                                    <slot></slot>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="px-4 py-3 bg-gray-50 sm:px-6 sm:flex sm:flex-row-reverse"
                    >
                        <span
                            class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto"
                        >
                            <button
                                type="button"
                                @click="close"
                                class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                            >
                                Fermer
                            </button>
                        </span>
                        <!-- <span class="flex w-full mt-3 rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5">
                Cancel
              </button>
            </span> -->
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        open: {
            type: Boolean,
            required: true
        },
        isIframe: {
            type: Boolean,
            default: false
        }
    },
    created() {
        const escapeHandler = e => {
            if (e.key === "Escape" && this.open) this.close();
        };
        document.addEventListener("keydown", escapeHandler);
        this.$once("hook:destroyed", () => {
            document.removeEventListener("keydown", escapeHandler);
        });
    },
    methods: {
        close() {
            this.$emit("modal-close");
        }
    }
};
</script>

<style></style>
